module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-09.dbe02e98.png";